/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { createItem, deleteItem, updateItem } from '../graphql';
import createMultiItems from '../graphql/mutation/createMultiItems';
import getRentitems from '../graphql/query/getRentitems';

export default () => {
  const [getsevs, itmData]: any = useLazyQuery(getRentitems);

  const [addRentitem] = useMutation(createItem, {
    refetchQueries: [{ query: getRentitems }],
  });
  const [addMultiRentitems] = useMutation(createMultiItems, {
    refetchQueries: [{ query: getRentitems }],
  });
  const [editRentitem] = useMutation(updateItem, {
    refetchQueries: [{ query: getRentitems }],
  });
  const [removeRentitem] = useMutation(deleteItem, {
    refetchQueries: [{ query: getRentitems }],
  });

  useEffect(() => {
    getsevs();
  }, [getsevs]);

  const rentitems = itmData?.data?.['getRentitems']?.data || [];
  const refreshrentitem = () => {
    itmData?.refetch();
  };

  return {
    rentitems,
    addRentitem,
    addMultiRentitems,
    editRentitem,
    removeRentitem,
    refreshrentitem,
    loading: itmData?.loading,
  };
};
